import { render, staticRenderFns } from "./MultipleRelationsMenu.vue?vue&type=template&id=70dcafd8&scoped=true&"
import script from "./MultipleRelationsMenu.vue?vue&type=script&lang=js&"
export * from "./MultipleRelationsMenu.vue?vue&type=script&lang=js&"
import style0 from "./MultipleRelationsMenu.vue?vue&type=style&index=0&id=70dcafd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dcafd8",
  null
  
)

export default component.exports